import { render, staticRenderFns } from "./PassportDataManualSection.vue?vue&type=template&id=31bfd6fa&"
import script from "./PassportDataManualSection.vue?vue&type=script&lang=js&"
export * from "./PassportDataManualSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports